import React from "react";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@mui/material";
import {fieldSx} from "../editMenuStyles";

// The custom param this field edits: it is saved (and sent) with the other custom params, under this fixed key
export const REASONING_EFFORT_KEY = "reasoning_effort";

export const REASONING_EFFORT_VALUES = ["none", "low", "medium", "high", "xhigh"];

/**
 * "Reasoning effort" of the AI nodes: a pick from a predefined list instead of free text. The value lives in
 * node.data.custom_params.reasoning_effort; "Default" removes the key, so nothing is sent for it.
 * Shown under Model in the AI Properties section; the Custom Params editor leaves this key out (hiddenKeys).
 */
export const ReasoningEffortField = ({node, setNode, onUpdate}) => {
    const value = node?.data?.custom_params?.[REASONING_EFFORT_KEY] || "";

    const change = (next) => {
        const customParams = {...(node?.data?.custom_params || {})};
        if (next) customParams[REASONING_EFFORT_KEY] = next;
        else delete customParams[REASONING_EFFORT_KEY];
        const updatedNode = {...node, data: {...node.data, custom_params: customParams}};
        setNode(updatedNode);
        onUpdate(updatedNode);
    };

    return (
        <FormControl size="small" sx={fieldSx}>
            <InputLabel id="reasoning-effort-label" shrink>Reasoning effort</InputLabel>
            <Select
                labelId="reasoning-effort-label"
                label="Reasoning effort"
                value={value}
                displayEmpty
                notched
                onChange={(e) => change(e.target.value)}
            >
                <MenuItem value=""><em>Default</em></MenuItem>
                {REASONING_EFFORT_VALUES.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
            <FormHelperText>How much the model thinks before answering. Sent as the custom param reasoning_effort.</FormHelperText>
        </FormControl>
    );
};
